export const APP_INIT = 'application/started'
export const APP_UPDATED = 'application/updated'
export const APP_FAILED = 'application/failed'
export const APP_LOADING = 'application/loading'
export const APP_LANGUAGE = 'application/language'
export const APP_REDIRECT = 'application/redirect'

export function setAppTranslationAction(translation) {
  return {
    type: APP_UPDATED,
    state: {
      translation,
    },
  }
}

export function setAppLoading(feature) {
  return {
    type: APP_LOADING,
    feature,
  }
}

export function setAppUpdated() {
  return {
    type: APP_UPDATED,
  }
}

export function setRedirectAction(redirectUrl) {
  return {
    type: APP_REDIRECT,
    redirectUrl,
  }
}

const ACTION_HANDLERS = {
  [APP_INIT]: state => ({
    ...state,
    loading: false,
    error: false,
  }),

  [APP_LOADING]: (state, action) => ({
    ...state,
    loading: true,
    error: false,
    feature: action.feature,
  }),

  [APP_UPDATED]: (state, action) => ({
    ...state,
    ...action.state,
    loading: false,
    error: false,
    feature: null,
  }),

  [APP_FAILED]: (state, action) => ({
    ...state,
    loading: false,
    error: action.error,
  }),

  [APP_LANGUAGE]: (state, action) => ({
    ...state,
    country: action.country,
    language: action.language,
  }),

  [APP_REDIRECT]: (state, action) => ({
    ...state,
    redirectUrl: action.redirectUrl,
  }),
}

const initialState = {
  loading: false,
  error: false,
  country: null,
  language: null,
  redirectUrl: null,
}

export default function reducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}
